/* EcoSparkle Home — Dishwasher Sheets Landing Page JS */

/* ── Add dishwasher sheets to cart with source tracking ── */
async function addDishwasherSheetsToCart() {
  try {
    const variantId = DISHWASHER_VARIANT_ID;

    if (!variantId) {
      // Fallback: redirect to product page if variant ID not set
      window.location.href = '/products/natural-dishwasher-tablets';
      return;
    }

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: { '_source': 'dishwasher-sheets-landing' }
        }]
      })
    });

    if (res.ok) {
      // Track conversion events
      if (window.gtag) {
        gtag('event', 'add_to_cart', {
          currency: 'ILS',
          source: 'dishwasher-sheets-landing'
        });
      }
      if (window.fbq) {
        fbq('track', 'AddToCart', {
          currency: 'ILS',
          source: 'dishwasher-sheets-landing'
        });
      }

      // Redirect to checkout
      window.location.href = '/checkout';
    } else {
      const err = await res.json();
      alert(err.description || 'משהו השתבש. נסו שוב.');
    }
  } catch (e) {
    console.error('Error adding to cart:', e);
    alert('שגיאת רשת. בדקו חיבור לאינטרנט ונסו שוב.');
  }
}

/* ── Sticky CTA (Mobile) ── */
(function initStickyCta() {
  const el = document.getElementById('stickyCta');
  if (!el) return;

  let ticking = false;

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(function () {
        const show = window.scrollY > 800;
        el.classList.toggle('visible', show);
        el.setAttribute('aria-hidden', String(!show));
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
})();

/* ── FAQ accordion ── */
(function initFaq() {
  document.querySelectorAll('.faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const expanded = btn.getAttribute('aria-expanded') === 'true';

      // Close all other FAQs
      document.querySelectorAll('.faq-q[aria-expanded="true"]').forEach(function (other) {
        if (other !== btn) {
          other.setAttribute('aria-expanded', 'false');
          other.nextElementSibling.hidden = true;
        }
      });

      // Toggle current FAQ
      btn.setAttribute('aria-expanded', String(!expanded));
      btn.nextElementSibling.hidden = expanded;
    });
  });
})();

/* ── Intersection observer fade-in ── */
(function initFadeIn() {
  const sections = document.querySelectorAll('.fade-in-section');

  if (!('IntersectionObserver' in window)) {
    sections.forEach(function (s) { s.classList.add('visible'); });
    return;
  }

  const obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.08 });

  sections.forEach(function (s) { obs.observe(s); });
})();

/* ── Smooth scroll anchors ── */
document.querySelectorAll('a[href^="#"]').forEach(function (a) {
  a.addEventListener('click', function (e) {
    const target = document.querySelector(a.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

/* ── Track CTA clicks ── */
document.querySelectorAll('[data-cta="add-to-cart"]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    if (window.gtag) {
      gtag('event', 'click', {
        event_category: 'engagement',
        event_label: 'cta_click',
        source: 'dishwasher-sheets-landing'
      });
    }
  });
});
